import ForgotPassword from './component'

export default ForgotPassword
